import cc from "classcat"
import Divided from "components/organisms/common/Divided"
import ScrollAnimate from "components/atoms/common/ScrollAnimate"

export const ListItem = ({
  title,
  number,
  className = "",
  textClass = "",
  theme,
}) => {
  return (
    <li
      className={cc([
        "relative flex aspect-square rounded-2xl p-4 hover:animate-scale lg:p-2 xl:p-4",
        {
          "bg-kkm-red ": theme === "dark",
          "bg-kkm-yellow ": theme === "darkyellow",
          "bg-kkm-red": theme === "light",
        },
        className,
      ])}
    >
      <div
        className={cc([
          "absolute -bottom-7 font-display text-6xl",
          {
            "text-zinc-100/30": theme === "dark",
            "text-zinc-700/30": theme === "light",
          },
        ])}
      >
        <span>{number}</span>
      </div>
      <p
        className={cc([
          "relative m-0 font-display",
          textClass ||
            "md:text-xl md:leading-6 lg:text-sm lg:leading-4 xl:text-base xl:leading-6",
          {
            "text-zinc-800": theme !== "dark",
            "text-zinc-50": theme === "dark",
          },
        ])}
      >
        {title}
      </p>
    </li>
  )
}

export default function NumberedListAnimated({
  title,
  items,
  Image,
  theme = "light",
  reversed,
}) {
  return (
    <Divided
      Image={Image}
      title={title}
      theme={theme}
      reversed={reversed}
      titleSize="lg"
      animateTitle
    >
      <ol className="m-0 grid list-none grid-cols-2 gap-6 xs:grid-cols-3">
        {items.map((item, index) => (
          <ScrollAnimate delay={index * 0.4 + 0.4}>
            <ListItem {...item} number={index + 1} theme={theme} />
          </ScrollAnimate>
        ))}
      </ol>
    </Divided>
  )
}
